import React from "react";
import { Building2, ChevronDown, MapPin } from "lucide-react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  getBranches,
  getSelectedBranch,
  setSelectedBranch,
} from "../../features/settings/settingsSlice";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { t } from "../../locales";

const BranchSelector = () => {
  const dispatch = useAppDispatch();
  const branches = useAppSelector(getBranches);
  const selectedBranch = useAppSelector(getSelectedBranch);

  if (branches.length <= 1) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center gap-2 px-3 py-2 rounded-md border border-[#34699A] bg-transparent text-sm font-normal text-[#113F67] hover:bg-[#113F67]/5 transition-colors focus:outline-none">
          <Building2 className="h-4 w-4 text-[#113F67]" />
          <span className="max-w-[128px] truncate">
            {selectedBranch?.name ?? t.branch.selectBranch}
          </span>
          <ChevronDown className="h-4 w-4 text-gray-400" />
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel className="text-[#113F67] font-semibold">{t.branch.dropdownLabel}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {branches.map((branch) => (
          <DropdownMenuItem
            key={branch.id}
            onClick={() => dispatch(setSelectedBranch(branch))}
            className={`cursor-pointer${selectedBranch?.id === branch.id ? " bg-[#113F67]/10" : ""}`}
          >
            <div className="flex items-center gap-2 w-full">
              <MapPin className="h-4 w-4 text-[#34699A]" />
              <div className="flex-1">
                <div className="font-medium text-sm">{branch.name}</div>
                <div className="text-xs text-gray-500">{branch.address}</div>
              </div>
            </div>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default BranchSelector;
